import './styles.scss';
import React from "react";

/* Bootstrap */
import {Modal} from "react-bootstrap";

interface IProps {
  title: string,
  message: string;
  show: boolean;
  onHide():void;
}

const NotifyModal = (props: IProps):JSX.Element => {
  const {
    title,
    message,
    show,
    onHide
  } = props;

  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop={false}
      enforceFocus={false}
      centered
      id={'notifications-modal'}
      className={'notifications-modal shadow rounded border-3'}
    >
      <Modal.Header className={'bg-success px-4 pt-2  bg-opacity-25'} closeButton>
          <Modal.Title className={'mt-2'}>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body className={'bg-success rounded-0 rounded-bottom pt-0 px-4 pb-4 '}>
        {message}
      </Modal.Body>
    </Modal>
  )
}
export default NotifyModal;
